import React from 'react';
import type { Size } from '../../types';

const chest = (width: Size = '298', height: Size = '398') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 298 398"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M293.983 225.39C297.294 198.224 292.476 170.687 280.138 146.26C267.799 121.832 248.495 101.612 224.665 88.1553C200.836 74.6986 173.551 68.6099 146.261 70.659C118.972 72.7082 92.9022 82.8031 71.3494 99.6674C49.7966 116.532 33.7282 139.408 25.1759 165.404C16.6237 191.4 15.9716 219.348 23.3022 245.715C30.6329 272.081 45.6169 295.682 66.3598 313.533C87.1028 331.384 112.673 342.684 139.838 346.003C157.879 348.208 176.178 346.837 193.689 341.968C211.201 337.1 227.581 328.829 241.896 317.628C256.21 306.428 268.178 292.517 277.115 276.691C286.052 260.864 291.784 243.432 293.983 225.39Z"
                fill="#1EC5F9"
            />
            <path
                d="M292.986 300.468C293.436 298.73 292.986 287.145 292.986 279.807C292.986 277.008 292.986 274.047 292.986 274.047C292.986 274.047 216.846 326.888 186.146 329.72C150.264 333.163 113.417 331.554 78.6298 321.868C51.0509 314.691 23.9226 297.443 24.4696 279.357L24.9202 301.69C25.1776 316.172 39.5302 330.363 67.7206 340.533C119.21 358.007 180.707 357.524 233.13 343.397C254.562 336.928 287.837 324.796 292.986 300.468Z"
                fill="url(#paint0_linear_10025_65881)"
            />
            <path
                d="M159.806 331.305C233.958 329.829 293.583 304.188 292.983 274.033C292.383 243.878 231.785 220.629 157.633 222.105C83.4813 223.58 23.8558 249.222 24.4559 279.376C25.0559 309.531 85.6543 332.78 159.806 331.305Z"
                fill="url(#paint1_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.9758 176.636C45.8338 207.688 46.5777 239.049 44.1963 270.25L169.701 319.036L281.047 275.302C278.461 243.74 279.227 211.994 283.332 180.594L128.864 147.416L41.9758 176.636Z"
                fill="url(#paint2_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.8472 176.636L169.862 218.792L283.332 180.594L128.703 147.416L41.8472 176.636Z"
                fill="url(#paint3_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.2687 176.604L128.928 151.503L268.528 181.431L169.83 214.641L54.2687 176.604Z"
                fill="url(#paint4_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M169.637 319.036L169.862 216.991L41.9758 176.636C44.5004 207.773 45.2418 239.028 44.1963 270.25L169.701 319.036H169.637Z"
                fill="url(#paint5_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M169.862 216.991L169.637 319.036L281.047 275.302C280.135 243.715 280.898 212.101 283.332 180.594L169.862 216.991Z"
                fill="url(#paint6_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M257.587 305.52L169.766 319.036L281.047 275.303L280.628 251.811C293.082 262.977 295.914 271.956 287.451 290.428L257.587 305.52Z"
                fill="url(#paint7_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.1115 206.95L141.929 232.18L142.38 284.924L67.3665 257.152L66.1115 206.95Z"
                fill="#B3B3B3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M197.473 232.02L258.198 211.649L257.329 262.302L197.151 284.893L197.473 232.02Z"
                fill="#B3B3B3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M70.1018 256.219L142.348 282.993L141.929 232.18L68.9111 207.884L70.1018 256.219Z"
                fill="url(#paint8_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M197.473 232.019L197.151 282.768L254.304 261.303L255.141 212.646L197.473 232.019Z"
                fill="url(#paint9_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.1115 206.95L67.3665 257.152L70.1019 256.219L68.9112 207.883L66.1115 206.95Z"
                fill="url(#paint10_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M142.348 282.993L70.1019 256.219L67.3665 257.152L142.38 284.924L142.348 282.993Z"
                fill="url(#paint11_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M254.304 261.304L197.151 282.768V284.892L257.329 262.301L254.304 261.304Z"
                fill="url(#paint12_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M255.141 212.647L254.305 261.304L257.33 262.302L258.198 211.649L255.141 212.647Z"
                fill="url(#paint13_linear_10025_65881)"
            />
            <g opacity="0.3">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M69.1042 215.639C75.9909 210.233 135.3 231.15 141.994 239.903V232.18L68.9111 207.884L69.1042 215.639Z"
                    fill="#041836"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.9758 176.636L169.862 216.991L281.401 181.238C276.96 183.684 253.918 191.343 228.013 199.774C207.932 206.21 184.504 212.904 169.862 218.793C151.616 211.552 118.373 202.348 92.3065 194.046C65.4678 185.486 43.4883 178.277 41.9758 176.636Z"
                fill="white"
            />
            <path
                d="M119.403 257.635C176.187 257.635 222.22 211.602 222.22 154.818C222.22 98.033 176.187 52 119.403 52C62.6182 52 16.5852 98.033 16.5852 154.818C16.5852 211.602 62.6182 257.635 119.403 257.635Z"
                fill="url(#paint14_radial_10025_65881)"
            />
            <path
                d="M107.303 202.799C132.896 202.799 153.643 182.052 153.643 156.459C153.643 130.866 132.896 110.119 107.303 110.119C81.7099 110.119 60.9626 130.866 60.9626 156.459C60.9626 182.052 81.7099 202.799 107.303 202.799Z"
                fill="url(#paint15_radial_10025_65881)"
            />
            <path
                d="M74.0599 202.799C99.6529 202.799 120.4 182.052 120.4 156.459C120.4 130.866 99.6529 110.119 74.0599 110.119C48.4669 110.119 27.7196 130.866 27.7196 156.459C27.7196 182.052 48.4669 202.799 74.0599 202.799Z"
                fill="url(#paint16_radial_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.5942 172.484L182.091 157.424C181.737 139.531 180.418 121.349 170.409 104.1C157.827 82.5393 137.649 73.3678 117.408 80.1901C93.8835 88.0744 76.7312 114.27 70.7456 138.115C68.3328 149.37 66.9434 160.819 66.5942 172.324V172.484Z"
                fill="url(#paint17_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M185.245 180.659L220.643 105.452L143.023 83.2476H142.669C135.093 81.1426 127.054 81.4008 119.628 83.9877C96.6832 91.518 80.0779 117.005 74.1566 140.368C73.9635 141.044 73.8026 141.752 73.6417 142.46L138.518 164.697L185.148 180.787L185.245 180.659Z"
                fill="url(#paint18_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M169.862 207.208L283.332 180.015C282.978 162.476 281.69 144.809 271.843 129.201C259.582 109.893 239.662 103.457 219.775 112.886C196.669 123.827 179.838 152.05 173.917 176.282C171.563 186.435 170.194 196.791 169.83 207.208H169.862Z"
                fill="url(#paint19_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M146.531 167.4L70.0696 141.205C70.2627 140.24 70.5202 139.242 70.7454 138.277C76.7311 114.27 93.8834 88.0424 117.408 80.3512C124.712 77.8232 132.592 77.4655 140.095 79.3214L116.7 72.4669L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C68.6537 80.4477 51.8231 106.192 45.9341 129.781C43.6039 140.837 42.2791 152.082 41.9758 163.378L169.862 207.208C170.216 196.793 171.574 186.436 173.917 176.282C179.806 151.889 196.637 123.827 219.742 112.886C228.32 108.557 238.179 107.494 247.482 109.893L220.579 102.202L217.972 101.43C209.089 99.4381 199.791 100.575 191.649 104.648C168.929 115.299 152.452 142.911 146.595 166.885C146.61 167.046 146.61 167.207 146.595 167.368L146.531 167.4Z"
                fill="url(#paint20_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M190.007 179.757L262.285 161.704C257.33 145.614 249.928 136.313 241.625 132.42C220.643 127.882 196.057 152.339 190.007 179.757Z"
                fill="url(#paint21_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M241.497 132.42C249.799 136.314 257.201 145.485 262.157 161.704L267.273 163.442C261.32 143.973 251.859 134.672 241.529 132.42H241.497Z"
                fill="url(#paint22_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M262.286 161.704L190.008 179.758C189.782 180.82 189.557 181.882 189.396 182.976L267.563 163.507L262.286 161.704Z"
                fill="url(#paint23_linear_10025_65881)"
            />
            <path
                opacity="0.65"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M217.972 101.43C210.537 99.7226 202.761 100.272 195.639 103.006C205.409 104.192 214.92 106.964 223.797 111.213C231.368 108.292 239.666 107.83 247.514 109.893L217.972 101.43ZM117.408 80.1903C123.89 77.9564 130.834 77.4137 137.585 78.6134C138.422 78.7743 139.258 78.9352 140.095 79.1605L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C100.559 74.3901 109.179 76.89 117.504 80.1903H117.408Z"
                fill="url(#paint24_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M78.3725 117.874C82.6624 109.238 88.3003 101.341 95.0743 94.4788C90.8587 94.7362 71.7755 90.424 69.8124 86.7554C63.1593 93.5016 57.6292 101.27 53.4324 109.765C58.9675 109.765 75.251 115.171 78.3725 117.874ZM173.048 118.26C166.029 125.566 160.149 133.887 155.606 142.943C163.104 142.557 180.225 149.379 183.089 151.889C187.719 142.66 193.707 134.178 200.852 126.724C195.864 126.917 175.591 120.803 173.048 118.26Z"
                fill="url(#paint25_radial_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M155.67 86.8517L142.798 83.1187C136.012 81.2046 128.828 81.2046 122.042 83.1187C146.176 88.5857 169.949 95.5393 193.225 103.94C193.998 103.586 194.77 103.296 195.542 103.006C198.384 101.965 201.329 101.231 204.328 100.818L155.67 86.8517Z"
                fill="url(#paint26_linear_10025_65881)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.747 191.6L169.862 207.208L217.232 195.944L171.214 204.44C172.244 176.604 175.397 166.209 188.785 141.977C174.818 162.798 170.087 176.926 168.865 204.569L123.747 191.6Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.2689 176.604L5.67596 133.096L0.140869 104.616L200.724 126.724C180.838 147.847 169.447 175.567 168.736 204.569L243.363 189.734L169.83 214.642L54.2689 176.604Z"
                fill="url(#paint27_linear_10025_65881)"
            />
            <path
                d="M168.736 317.684C168.414 283.894 168.124 250.555 168.253 216.991L169.379 218.503L41.9758 176.636C45.0227 207.765 46.3012 239.041 45.8053 270.314L44.7756 268.769C86.0957 284.828 127.223 301.143 168.736 317.684ZM170.538 320.355C128.349 304.265 85.7417 288.174 43.4883 271.762C43.1728 271.641 42.9035 271.423 42.7186 271.14C42.5338 270.857 42.4428 270.523 42.4585 270.185C44.0675 239.018 43.9063 207.785 41.9758 176.636L170.345 215.446C170.671 215.543 170.956 215.743 171.159 216.015C171.362 216.288 171.472 216.619 171.471 216.958C171.439 251.456 171.021 286.115 170.699 320.355H170.538Z"
                fill="url(#paint28_linear_10025_65881)"
            />
            <path
                d="M171.15 217.924V319.036L168.961 317.523C168.961 317.523 282.045 274.111 280.661 275.302C279.893 243.708 280.785 212.095 283.332 180.594C245.648 193.241 208.351 205.759 171.15 217.924ZM168.543 216.025C207.16 203.957 245.358 192.211 283.332 180.626C281.042 212.13 280.409 243.732 281.433 275.302C281.723 276.139 170.377 320.098 170.216 320.548C169.972 320.643 169.708 320.676 169.447 320.645C169.187 320.614 168.938 320.52 168.722 320.371C168.507 320.222 168.331 320.022 168.21 319.789C168.089 319.557 168.026 319.298 168.028 319.036L168.543 216.057V216.025Z"
                fill="#AAF4F1"
            />
            <path
                d="M204.167 101.076L164.552 89.5872L144.729 83.8912C138.197 81.7048 131.203 81.2829 124.455 82.6683C98.7106 88.654 82.2018 113.53 75.0255 137.376L74.3497 139.886C74.0923 140.69 73.867 141.527 75.3152 142.718C75.2695 142.925 75.1832 143.122 75.0613 143.296C74.9393 143.47 74.7841 143.618 74.6046 143.731C74.4251 143.845 74.2248 143.922 74.0154 143.958C73.8059 143.994 73.5914 143.988 73.3843 143.941C73.178 143.899 72.9823 143.816 72.8085 143.697C72.6347 143.578 72.4865 143.426 72.3725 143.249C72.2585 143.072 72.1812 142.874 72.1449 142.667C72.1087 142.459 72.1143 142.247 72.1614 142.042C73.9957 141.527 74.1566 140.722 74.3497 139.886L75.0255 137.376C83.1351 107.898 110.682 73.0141 144.826 83.505C157.505 87.1093 191.262 96.6026 204.36 100.271C204.778 100.271 204.65 101.108 204.167 100.979V101.076Z"
                fill="#AAF4F1"
            />
            <path
                d="M170.892 205.985C207.996 197.103 245.326 188.543 283.332 180.015C283.283 170.627 282.356 161.265 280.564 152.05C278.76 142.871 275.019 134.181 269.59 126.563C264.273 118.861 256.503 113.189 247.547 110.472C238.541 108.15 228.999 109.155 220.676 113.304C212.356 117.407 204.956 123.154 198.921 130.199C192.802 137.233 187.64 145.045 183.571 153.434C179.506 161.775 176.48 170.583 174.561 179.661C173.602 184.19 172.882 188.766 172.404 193.37C172.168 195.687 171.975 198.004 171.825 200.321L171.6 203.829V204.698C171.6 204.987 171.6 205.341 171.6 205.341C171.6 205.341 171.214 205.631 170.892 205.985ZM168.832 208.463C168.527 207.539 168.375 206.572 168.382 205.599C168.358 205.224 168.358 204.847 168.382 204.472V203.603L168.639 200.096C168.832 197.747 169.058 195.397 169.347 193.048C169.898 188.344 170.693 183.671 171.729 179.05C173.852 169.798 177.094 160.84 181.383 152.372C185.688 143.896 191.099 136.029 197.473 128.976C203.742 121.816 211.408 116.012 220 111.92C228.706 107.752 238.623 106.86 247.933 109.41C257.117 112.265 265.059 118.154 270.459 126.112C275.814 133.842 279.477 142.615 281.208 151.857C282.843 161.098 283.629 170.47 283.557 179.854C245.68 189.605 207.353 199.291 168.832 208.463Z"
                fill="url(#paint29_linear_10025_65881)"
            />
            <path
                d="M147.336 168.816C121.591 160.288 95.3958 151.632 69.5547 142.75C69.1831 142.63 68.8703 142.375 68.6793 142.035C68.4883 141.695 68.4331 141.295 68.5249 140.915C70.5377 132.39 73.6647 124.167 77.8251 116.458C81.9112 108.744 87.0684 101.648 93.1432 95.3795C99.1935 89.0661 106.523 84.1179 114.64 80.866C122.733 77.5748 131.673 76.9878 140.127 79.1926L120.819 73.8828C117.601 73.0783 114.382 71.9519 111.164 71.437C107.911 70.8959 104.599 70.7877 101.317 71.1152C88.0586 72.4668 76.4092 80.3833 67.7526 90.1019C59.0683 100.063 52.5774 111.74 48.7015 124.374C44.7111 136.893 44.0997 150.119 43.3917 163.474L42.2976 161.865L170.345 205.695L168.221 207.111C168.8 195.316 170.711 183.625 173.917 172.259C177.303 160.93 182.404 150.186 189.042 140.4C195.497 130.506 203.988 122.102 213.95 115.75C218.816 112.478 224.316 110.266 230.093 109.257C235.87 108.248 241.794 108.465 247.482 109.893L230.973 105.162L222.703 102.813C219.985 101.911 217.197 101.233 214.368 100.786C208.68 100.094 202.909 100.676 197.473 102.491C192.063 104.348 186.972 107.029 182.38 110.44C173.3 117.417 165.743 126.178 160.176 136.185C157.299 141.084 154.845 146.22 152.838 151.535C151.809 154.174 150.908 156.877 150.103 159.58C149.717 160.964 149.299 162.283 149.009 163.667L148.526 165.727L148.301 166.789V167.304C148.129 167.889 147.794 168.414 147.336 168.816ZM145.759 165.984C145.616 166.007 145.482 166.067 145.369 166.157C145.256 166.247 145.169 166.365 145.115 166.499L145.276 165.984L145.598 164.954L146.241 162.863C146.66 161.479 147.207 160.127 147.657 158.743C148.623 156.008 149.653 153.305 150.875 150.698C153.243 145.426 155.963 140.319 159.017 135.412C165.066 125.625 172.918 117.075 182.155 110.215C186.809 106.824 191.968 104.185 197.441 102.395C202.919 100.62 208.724 100.092 214.432 100.85C217.248 101.327 220.023 102.016 222.735 102.91L231.006 105.259L247.514 109.99C241.833 108.658 235.934 108.543 230.205 109.652C224.475 110.762 219.046 113.07 214.272 116.426C204.586 122.896 196.399 131.367 190.265 141.269C183.958 151.014 179.193 161.673 176.137 172.871C173.288 184.124 171.733 195.666 171.503 207.272C171.478 207.696 171.29 208.094 170.978 208.382C170.666 208.67 170.255 208.826 169.83 208.817C169.691 208.835 169.55 208.835 169.412 208.817L41.3 164.922C40.9699 164.809 40.6866 164.59 40.4944 164.299C40.3023 164.008 40.2121 163.661 40.238 163.313C41.2034 150.087 42.1045 136.507 46.4811 123.666C50.6841 110.845 57.5491 99.0556 66.6262 89.0721C75.669 79.4179 87.7368 71.437 101.317 70.3429C104.662 70.095 108.024 70.268 111.325 70.8578C114.543 71.4692 117.761 72.6599 120.98 73.5288L140.095 79.2248C131.656 77.2852 122.815 78.132 114.897 81.6383C107.047 85.0787 100.016 90.1462 94.2695 96.5059C88.5233 102.819 83.7018 109.916 79.9491 117.584C76.1405 125.199 73.349 133.281 71.6464 141.623L70.5845 139.757C95.7176 148.285 120.593 157.07 145.759 165.984Z"
                fill="url(#paint30_linear_10025_65881)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_10025_65881"
                    x1="24.4374"
                    y1="313.951"
                    x2="293.34"
                    y2="313.951"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_10025_65881"
                    x1="24.4382"
                    y1="276.725"
                    x2="292.954"
                    y2="276.725"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_10025_65881"
                    x1="82.2983"
                    y1="163.442"
                    x2="274.417"
                    y2="309.767"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.34" stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_10025_65881"
                    x1="143.764"
                    y1="206.789"
                    x2="182.928"
                    y2="148.188"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.29" stopColor="white" />
                    <stop
                        offset="0.77"
                        stopColor="#7FEFEA"
                        stopOpacity="0.32"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_10025_65881"
                    x1="149.749"
                    y1="182.975"
                    x2="233.837"
                    y2="161.865"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_10025_65881"
                    x1="92.3709"
                    y1="291.167"
                    x2="119.596"
                    y2="202.863"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="white" />
                    <stop offset="0.5" stopColor="#AAF4F1" />
                    <stop offset="1" stopColor="#42E8E0" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_10025_65881"
                    x1="152.002"
                    y1="218.664"
                    x2="324.716"
                    y2="290.878"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90CFEB" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_10025_65881"
                    x1="337.234"
                    y1="349.865"
                    x2="235.447"
                    y2="291.393"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#29A2D9" stopOpacity="0" />
                    <stop offset="1" stopColor="#3879B2" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_10025_65881"
                    x1="1711.69"
                    y1="4791.09"
                    x2="3387.51"
                    y2="4791.09"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_10025_65881"
                    x1="3805.27"
                    y1="4541.27"
                    x2="4850.25"
                    y2="4541.27"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_10025_65881"
                    x1="151.905"
                    y1="3061.44"
                    x2="156.853"
                    y2="3061.44"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90CFEB" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_10025_65881"
                    x1="67.3665"
                    y1="270.572"
                    x2="142.38"
                    y2="270.572"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="white" />
                    <stop offset="1" stopColor="#42E8E0" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_10025_65881"
                    x1="3941.43"
                    y1="1903.54"
                    x2="5066.76"
                    y2="1903.54"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="white" />
                    <stop offset="1" stopColor="#42E8E0" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_10025_65881"
                    x1="568.111"
                    y1="3567.89"
                    x2="568.111"
                    y2="2770.61"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90CFEB" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <radialGradient
                    id="paint14_radial_10025_65881"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(119.403 154.818) scale(102.818)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint15_radial_10025_65881"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(107.303 156.459) scale(46.3403)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.13" stopColor="white" stopOpacity="0.98" />
                    <stop offset="0.26" stopColor="white" stopOpacity="0.94" />
                    <stop offset="0.38" stopColor="white" stopOpacity="0.86" />
                    <stop offset="0.5" stopColor="white" stopOpacity="0.75" />
                    <stop offset="0.63" stopColor="white" stopOpacity="0.61" />
                    <stop offset="0.75" stopColor="white" stopOpacity="0.44" />
                    <stop offset="0.87" stopColor="white" stopOpacity="0.24" />
                    <stop offset="0.99" stopColor="white" stopOpacity="0.01" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint16_radial_10025_65881"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(74.0599 156.459) scale(46.3403)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.13" stopColor="white" stopOpacity="0.83" />
                    <stop offset="0.37" stopColor="white" stopOpacity="0.54" />
                    <stop offset="0.59" stopColor="white" stopOpacity="0.31" />
                    <stop offset="0.77" stopColor="white" stopOpacity="0.14" />
                    <stop offset="0.92" stopColor="white" stopOpacity="0.04" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint17_linear_10025_65881"
                    x1="66.5942"
                    y1="123.353"
                    x2="182.091"
                    y2="123.353"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.06" stopColor="#43E8E1" />
                    <stop offset="0.64" stopColor="#3A8FA2" />
                    <stop offset="1" stopColor="#387E97" />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_10025_65881"
                    x1="96.6837"
                    y1="153.659"
                    x2="148.173"
                    y2="90.9064"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#153A61" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_10025_65881"
                    x1="6269.4"
                    y1="-216.217"
                    x2="10271.5"
                    y2="-216.217"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90CFEB" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_10025_65881"
                    x1="124.037"
                    y1="37.8077"
                    x2="16.9113"
                    y2="268.205"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="white" />
                    <stop offset="1" stopColor="#42E8E0" />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_10025_65881"
                    x1="4523.07"
                    y1="73.0144"
                    x2="6150.05"
                    y2="73.0144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_10025_65881"
                    x1="2274.25"
                    y1="-126.027"
                    x2="2338.4"
                    y2="102.212"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90CFEB" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint23_linear_10025_65881"
                    x1="4860.66"
                    y1="451.329"
                    x2="6759.34"
                    y2="451.329"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="white" />
                    <stop offset="1" stopColor="#42E8E0" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_10025_65881"
                    x1="164.295"
                    y1="110.44"
                    x2="170.892"
                    y2="86.6586"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.64" stopColor="white" stopOpacity="0" />
                    <stop
                        offset="0.76"
                        stopColor="#CDD1EA"
                        stopOpacity="0.32"
                    />
                    <stop offset="1" stopColor="#616DBE" />
                </linearGradient>
                <radialGradient
                    id="paint25_radial_10025_65881"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(134.753 67.5805) rotate(2.86241) scale(184.948 184.487)"
                >
                    <stop stopColor="#B18654" />
                    <stop offset="1" stopColor="#000505" />
                </radialGradient>
                <linearGradient
                    id="paint26_linear_10025_65881"
                    x1="151.391"
                    y1="81.251"
                    x2="149.106"
                    y2="90.0251"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#153A61" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint27_linear_10025_65881"
                    x1="9415.27"
                    y1="5029.38"
                    x2="9423.24"
                    y2="2970.67"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint28_linear_10025_65881"
                    x1="40.2381"
                    y1="248.496"
                    x2="171.471"
                    y2="248.496"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#AAF4F1" />
                </linearGradient>
                <linearGradient
                    id="paint29_linear_10025_65881"
                    x1="6301.48"
                    y1="3515.19"
                    x2="10478.5"
                    y2="3515.19"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#AAF4F1" />
                </linearGradient>
                <linearGradient
                    id="paint30_linear_10025_65881"
                    x1="9463.21"
                    y1="6940.49"
                    x2="9499.36"
                    y2="940.353"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default chest;
